import React from 'react';

interface IProps {
  data: {
    title: string,
    description: string,
    notification_links: {
      web: {
        href: string,
      },
    },
  },
}

function ReverbHeaderUserNotification({ data }: IProps) {
  const link = data?.notification_links?.web?.href;
  if (!link) { return null; }

  // Remove domain to preseve ORIGIN for admin.reverb.tools
  const loc = new URL(link);
  const href = loc.pathname + loc.search + loc.hash;

  return (
    <li>
      <a
        className="reverb-header__menu__link reverb-header__menu__link--new-feature"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {data.title}
        <span className="reverb-header__menu__link-subtitle">
          {data.description}
        </span>
      </a>
    </li>
  );
}

export default ReverbHeaderUserNotification;
